// document.addEventListener('DOMContentLoaded', () => {
//     console.log("h chargé");
//     const triggerButton = document.querySelector('.mw-header-primary-menu__trigger');
//     const siteLogo = document.querySelector('.mw-site-logo');
//     const headerContainer = document.querySelector('header > .mw-container > .mw-container:last-child');
//     const searchButton = document.querySelector('.mw-search-button');
//     if (triggerButton) {
//         console.log('trigger'.triggerButton);
//         triggerButton.addEventListener('click', () => {
//             const isExpanded = triggerButton.getAttribute("aria-expanded") !== "false";
//             const controlElement = document.getElementById(triggerButton.getAttribute('aria-controls'));
//             const classCloseBtn = 'mw-header-primary-menu__close-btn';

//             if (controlElement) {
//                 console.log('controlElement'.controlElement);
//                 if (isExpanded) {
//                     console.log('isExpanded'.isExpanded);
//                     triggerButton.classList.remove(classCloseBtn);
//                     searchButton.style.display = 'none';
//                     controlElement.classList.remove('active');
//                     if(siteLogo) {
//                         siteLogo.classList.remove('active');
//                     }
//                     if(headerContainer) {
//                         headerContainer.classList.remove('active');
//                     }
//                     if(searchButton) {
//                         searchButton.style.display = 'inline-flex';
//                     }
//                 } else {
//                     triggerButton.classList.add(classCloseBtn);
//                     controlElement.classList.add('active');
//                     if(siteLogo) {
//                         siteLogo.classList.add('active');
//                     }
//                     if(headerContainer) {
//                         headerContainer.classList.add('active');
//                     }
//                     if(searchButton) {
//                         searchButton.style.display = 'none';
//                     }
//                 }
//                 triggerButton.setAttribute("aria-expanded", !isExpanded);
//             }

//         });
//     }

//     let lastScrollTop = 0;

//     window.addEventListener('scroll', () => {
//     const topBarMenu = document.querySelector('.secondary-menu-mobile');
//     const headerMenu = document.querySelector('.container-header-menu');

//     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

//     if (topBarMenu){
//         topBarMenu.style.transition = 'top 0.25s ease';
//     } 
//     if (headerMenu){
//         headerMenu.style.transition = 'top 0.25s ease';
//     } 

//     if (scrollTop > lastScrollTop) {
//         if(topBarMenu){
//             topBarMenu.style.top = `-${topBarMenu.offsetHeight}px`;
//         } 
//         // if window = 1280px 
//         if (window.innerWidth < 1280 && window.innerWidth >= 744) {
//             if (headerMenu){
//                 headerMenu.style.top = '-45px';
//             }
//         }
//         else if(window.innerWidth < 1280){
//             if (headerMenu){
//                 headerMenu.style.top = '-38px';
//             }
//         }
//         else{
//             headerMenu.style.top = '-50px';
//         }
//     } else if (scrollTop <= 10) {
//         if (topBarMenu){
//             topBarMenu.style.top = '0';
//         } 
//         if (headerMenu){
//             headerMenu.style.top = '0';
//         } 
//     }

//     lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
//     });



// });


// document.addEventListener("DOMContentLoaded", function () {
//   const setParentLevel1WidthForElement = (el, open) => {
//         const parentLvl1Menu = el.closest(".mw-header-primary-menu__wrapper--level-1");
//         if (!parentLvl1Menu) return;

//         const li = el.closest('li');
//         if (open) {
//             if (!li) {
//                 parentLvl1Menu.style.width = '';
//                 return;
//             }
//             if (li.classList.contains('mw-header-primary-menu__item--level-2')) {
//                 parentLvl1Menu.style.width = '800px';
//             } else if (li.classList.contains('mw-header-primary-menu__item--level-3')) {
//                 parentLvl1Menu.style.width = '995px';
//             } else {
//                 parentLvl1Menu.style.width = '';
//             }
//             return;
//         }

//         if (!li) {
//             parentLvl1Menu.style.width = '';
//             return;
//         }

//         if (li.classList.contains('mw-header-primary-menu__item--level-3')) {
//             parentLvl1Menu.style.width = '800px';
//             return;
//         }

//         if (li.classList.contains('mw-header-primary-menu__item--level-2')) {
//             parentLvl1Menu.style.width = '';
//             return;
//         }

//         parentLvl1Menu.style.width = '';
//     };
//     const buttons = document.querySelectorAll(".mw-header-primary-menu__item button");

//     buttons.forEach(button => {
//         button.addEventListener("click", function (event) {
//             event.stopPropagation(); // Empêche la fermeture immédiate

//             const subMenuId = this.getAttribute("aria-controls");
//             const subMenu = document.getElementById(subMenuId);
//             const isOpen = this.getAttribute("aria-expanded") === "true";
//             const parentLi = this.closest("li");

//             // Ferme uniquement les sous-menus du même niveau
//             const parentMenu = this.closest(".mw-header-primary-menu__wrapper") || document;
//             parentMenu.querySelectorAll(".mw-header-primary-menu__wrapper").forEach(menu => {
//                 if (menu !== subMenu) {
//                     menu.style.display = "none";
//                     menu.previousElementSibling?.setAttribute("aria-expanded", "false");

//                     const otherLi = menu.closest("li");
//                     if (otherLi) {
//                         otherLi.classList.remove("is-open");
//                     }
//                 }
//             });

//             // Toggle du menu actuel
//             if (!isOpen) {
//                 subMenu.style.display = "block";
//                 this.setAttribute("aria-expanded", "true");
//                 if (parentLi){
//                     parentLi.classList.add("is-open");
//                     setParentLevel1WidthForElement(this, true);
//                 }
                    
//             } else {
//                 subMenu.style.display = "none";
//                 this.setAttribute("aria-expanded", "false");
//                 if (parentLi){
//                     parentLi.classList.remove("is-open");
//                     setParentLevel1WidthForElement(this, false);
//                 }
//             }
//         });
//     });

//     // Fermer tout le menu si on clique en dehors
//     document.addEventListener("click", function (event) {
//         if (!event.target.closest(".mw-header-primary-menu")) {
//             document.querySelectorAll(".mw-header-primary-menu__wrapper:not(.mw-header-primary-menu__wrapper--level-0)").forEach(menu => {
//                 menu.style.display = "none";
//             });

//             document.querySelectorAll(".mw-header-primary-menu__item button").forEach(btn => {
//                 btn.setAttribute("aria-expanded", "false");
//             });
//         }
//     });
// });